import { render, staticRenderFns } from "./pendingEdit.vue?vue&type=template&id=9d35ee78&"
import script from "./pendingEdit.vue?vue&type=script&lang=js&"
export * from "./pendingEdit.vue?vue&type=script&lang=js&"
import style0 from "./pendingEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports